"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaPage = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mediaSection = require("../../mediaSection");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaPage = props => {
  const {
    mediaData,
    t,
    mediaDescriptions = {}
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content"
  }, /*#__PURE__*/_react.default.createElement(_mediaSection.MediaSection, {
    t: t,
    mediaSectionData: mediaData.articles,
    sectionType: "Articles",
    mediaDescription: mediaDescriptions.articles
  }), /*#__PURE__*/_react.default.createElement(_mediaSection.MediaSection, {
    t: t,
    mediaSectionData: mediaData.magazines,
    sectionType: "Magazines",
    mediaDescription: mediaDescriptions.magazines
  })));
};
exports.MediaPage = MediaPage;
MediaPage.propTypes = {
  mediaData: _propTypes.default.object,
  t: _propTypes.default.func,
  mediaDescriptions: _propTypes.default.object
};